import _ from 'lodash'
import BaseViewModel from '../../../infraestructure/BaseViewModel'
import KnowledgeArea from '../models/KnowledgeArea'

export default class KnowledgeAreaViewModel extends BaseViewModel {
    constructor(view) {
        super(view)
    }
    // INICIALIZADORES

    //#region CRUD

    onCreate() {
        let item = new KnowledgeArea({
            state: "create",
            status: 1
        });
        return item;
    }

    onDelete(data) {
        let item = new KnowledgeArea(data);
        item.state = "delete";
        return item;
    }

    onEdit(data) {
        let item = new KnowledgeArea(data);
        item.state = "update";
        return item;
    }

    onSearchCollection() {
        return this.api.knowledgeAreas.find(this.getSearchQuery())
    }

    mapCollection(collection) {
        return _.map(collection, (data) => new KnowledgeArea(data));
    }

    onSearchItem(id) {
        return this.api.knowledgeAreas.findOne(id)
    }

    onSave(data) {
        if (data.state === 'create')
            return this.api.knowledgeAreas.create(data.toSend())
        else
            return this.api.knowledgeAreas.update(data.id, data.toSend());
    }

    onDestroy(context, id) {
        context.api.knowledgeAreas.delete(id)
            .then(response => context.view.onSuccess(response.data))
            .catch(context.view.onError)
    }

    onCancel(context) {
        context.view.item = null;
    }

    import(file) {
        this.api.knowledgeAreas.import(file)
            .then(response => this.view.onImportResponse(response.data))
            .catch(this.view.onError)
    }

    exportToExcel() {
        this.api.knowledgeAreas.exportToExcel()
            .then(response => this.view.onExportResponse(response.data))
            .catch(this.view.onError)
    }

    // #endregion

    // #region BINDING DATA

    bindFormView(formData) {
        if (formData.state === 'update') {
            this.api.universities.find()
                .then((response) => {
                    this.view.universities = response.data.data;

                })
                .catch(this.view.onError);
        }
        setTimeout(() => {
            this.showModalLoading(this.view.conf, false);
        }, 400);
    }

    // #endregion

    // #region QUERIES

    /**
       * Metodo para buscar Universidades
       * @param {String} data Query string para parametros de búsqueda
       */
    findUniversities(data) {
        this.api.universities.find(data)
            .then((response) => {
                this.view.onFindUniversitiesResponse(response.data.data)
            })
            .catch(this.view.onError)
    }


    // #endregion

    //#region MAPPING DATA


    // #endregion

    // #region VALIDATIONS

    // #endregion
}
